function KeychainSelect() {
  return (
    <div className="keychains">
      <div class="row">
        <div class="col">
          <div class="collapse multi-collapse mb-3" id="multiCollapseExample1">
            <div class="card card-body">
              <p className="card-text">
                {" "}
                <strong>Ash</strong> <br /> Inv: 1
              </p>
            </div>
            <div class="card card-body">
              <p className="card-text">
                {" "}
                <strong>Aspen</strong> <br /> Inv: 1
              </p>
            </div>

            <div class="card card-body">
              <p className="card-text">
                {" "}
                <strong>Frankie</strong> <br /> Inv: 1
              </p>
            </div>
            <div class="card card-body">
              <p className="card-text">
                {" "}
                <strong>Hazel</strong> <br /> Inv: 1
              </p>
            </div>
            <div class="card card-body">
              <p className="card-text">
                {" "}
                <strong>Honey</strong> <br /> Inv: 1
              </p>
            </div>
            <div class="card card-body">
              <p className="card-text">
                {" "}
                <strong>Maeve</strong> <br /> Inv: 1
              </p>
            </div>
            <div class="card card-body">
              <p className="card-text">
                {" "}
                <strong>Mavis</strong> <br /> Inv: 1
              </p>
            </div>
            <div class="card card-body">
              <p className="card-text">
                {" "}
                <strong>Nova</strong> <br /> Inv: 1
              </p>
            </div>
            <div class="card card-body">
              <p className="card-text">
                {" "}
                <strong>Natalie</strong> <br /> Inv: 1
              </p>
            </div>
            <div class="card card-body">
              <p className="card-text">
                {" "}
                <strong>Olive</strong> <br /> Inv: 1
              </p>
            </div>

            <div class="card card-body">
              <p className="card-text">
                {" "}
                <strong>Zuri</strong> <br /> Inv: 1
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="collapse multi-collapse mb-3" id="multiCollapseExample2">
            <div class="card card-body">
              <p className="card-text">
                {" "}
                <strong>April</strong> <br /> Inv: 1
              </p>
            </div>

            <div class="card card-body">
              <p className="card-text">
                {" "}
                <strong>Becca</strong> <br /> Inv: 1
              </p>
            </div>

            <div class="card card-body">
              <p className="card-text">
                {" "}
                <strong>Cora</strong> <br /> Inv: 1
              </p>
            </div>
            <div class="card card-body">
              <p className="card-text">
                {" "}
                <strong>Daisy</strong> <br /> Inv: 1
              </p>
            </div>

            <div class="card card-body">
              <p className="card-text">
                {" "}
                <strong>Lila</strong> <br /> Inv: 1
              </p>
            </div>
            <div class="card card-body">
              <p className="card-text">
                {" "}
                <strong>Linnea</strong> <br /> Inv: 1
              </p>
            </div>
            <div class="card card-body">
              <p className="card-text">
                {" "}
                <strong>Mae</strong> <br /> Inv: 1
              </p>
            </div>

            <div class="card card-body">
              <p className="card-text">
                {" "}
                <strong>Pearl</strong> <br /> Inv: 1
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="collapse multi-collapse mb-3" id="multiCollapseExample3">
            <div class="card card-body">
              <p className="card-text">
                {" "}
                <strong>Billie</strong> <br /> Inv: 1
              </p>
            </div>
            <div class="card card-body">
              <p className="card-text">
                {" "}
                <strong>Chloe</strong> <br /> Inv: 1
              </p>
            </div>
            <div class="card card-body">
              <p className="card-text">
                {" "}
                <strong>Elliot</strong> <br /> Inv: 1
              </p>
            </div>
            <div class="card card-body">
              <p className="card-text">
                {" "}
                <strong>Esme</strong> <br /> Inv: 1
              </p>
            </div>
            <div class="card card-body">
              <p className="card-text">
                {" "}
                <strong>Etta</strong> <br /> Inv: 1
              </p>
            </div>
            <div class="card card-body">
              <p className="card-text">
                {" "}
                <strong>Freya</strong> <br /> Inv: 1
              </p>
            </div>
            <div class="card card-body">
              <p className="card-text">
                {" "}
                <strong>June</strong> <br /> Inv: 1
              </p>
            </div>

            <div class="card card-body">
              <p className="card-text">
                {" "}
                <strong>Tilly</strong> <br /> Inv: 1
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="collapse multi-collapse mb-3" id="multiCollapseExample4">
            <div class="card card-body">
              <p className="card-text">
                {" "}
                <strong>Blair</strong> <br /> Inv: 2
              </p>
            </div>
            <div class="card card-body">
              <p className="card-text">
                {" "}
                <strong>Conrad</strong> <br /> Inv: 1
              </p>
            </div>
            <div class="card card-body">
              <p className="card-text">
                {" "}
                <strong>Fiona</strong> <br /> Inv: 1
              </p>
            </div>
            <div class="card card-body">
              <p className="card-text">
                {" "}
                <strong>Hank</strong> <br /> Inv: 2
              </p>
            </div>
            <div class="card card-body">
              <p className="card-text">
                {" "}
                <strong>Iris</strong> <br /> Inv: 1
              </p>
            </div>

            <div class="card card-body">
              <p className="card-text">
                {" "}
                <strong>Joan</strong> <br /> Inv: 2
              </p>
            </div>
            <div class="card card-body">
              <p className="card-text">
                {" "}
                <strong>Kennedy</strong> <br /> Inv: 1
              </p>
            </div>

            <div class="card card-body">
              <p className="card-text">
                {" "}
                <strong>Priya</strong> <br /> Inv: 2
              </p>
            </div>
            <div class="card card-body">
              <p className="card-text">
                {" "}
                <strong>Rachel</strong> <br /> Inv: 2
              </p>
            </div>

            <div class="card card-body">
              <p className="card-text">
                {" "}
                <strong>Sally</strong> <br /> Inv: 1
              </p>
            </div>
            <div class="card card-body">
              <p className="card-text">
                {" "}
                <strong>Tanner</strong> <br /> Inv: 2
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default KeychainSelect;
